import { useEffect, useRef, useState } from 'react';
import type { CSSProperties } from 'react';

// Botón "+ Nuevo" con menú, compartido por todas las secciones con creación.
// Orden Hilo / Recordatorio: el sistema gira en torno a los hilos; el
// recordatorio es una feature adicional.
export default function NuevoButton({ onHilo, onRecordatorio }: { onHilo: () => void; onRecordatorio: () => void }) {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!open) return undefined;
    const onClick = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false);
    };
    document.addEventListener('mousedown', onClick);
    return () => document.removeEventListener('mousedown', onClick);
  }, [open]);

  const pick = (fn: () => void) => { setOpen(false); fn(); };

  return (
    <div ref={ref} style={{ position: 'relative' }}>
      <button type="button" onClick={() => setOpen((o) => !o)} style={styles.btn}>
        + Nuevo
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" style={{ marginLeft: 6 }}>
          <path d="M6 9l6 6 6-6" />
        </svg>
      </button>
      {open && (
        <div style={styles.menu}>
          <button
            type="button"
            onClick={() => pick(onHilo)}
            style={styles.item}
            onMouseEnter={(e) => { e.currentTarget.style.background = '#f8fafc'; }}
            onMouseLeave={(e) => { e.currentTarget.style.background = 'transparent'; }}
          >
            Hilo
          </button>
          <button
            type="button"
            onClick={() => pick(onRecordatorio)}
            style={styles.item}
            onMouseEnter={(e) => { e.currentTarget.style.background = '#f8fafc'; }}
            onMouseLeave={(e) => { e.currentTarget.style.background = 'transparent'; }}
          >
            Recordatorio
          </button>
        </div>
      )}
    </div>
  );
}

const styles: Record<string, CSSProperties> = {
  btn: {
    display: 'inline-flex', alignItems: 'center', background: '#16a34a', color: '#fff', border: 'none',
    borderRadius: 10, padding: '11px 18px', fontSize: 14, fontWeight: 600, cursor: 'pointer', whiteSpace: 'nowrap',
  },
  menu: {
    position: 'absolute', top: 'calc(100% + 6px)', right: 0, minWidth: 180,
    background: '#fff', border: '1px solid #e2e8f0', borderRadius: 10,
    boxShadow: '0 12px 28px rgba(15,23,42,0.16)', overflow: 'hidden', zIndex: 200, padding: 4,
  },
  item: {
    width: '100%', textAlign: 'left', background: 'transparent', border: 'none', cursor: 'pointer',
    padding: '10px 12px', borderRadius: 8, fontSize: 14, fontWeight: 600, color: '#0f172a',
  },
};
